import BaseEntity from '../baseclasses/BaseEntity'
export class SpecificModelReason extends BaseEntity{
    ID?: number;
    Name?: string;
}

export default SpecificModelReason;